import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  createSecurityClass,
  getAllSecurityClasses,
  updateSecurityClass,
  deleteSecurityClass,
} from "../api/securityClass";

export function useGetSecurityClasses() {
  return useQuery({
    queryKey: ["securityClasses"],
    queryFn: getAllSecurityClasses,
  });
}

export function useCreateSecurityClass() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: "createSecurityClass",
    mutationFn: createSecurityClass,
    onSuccess: () => {
      queryClient.invalidateQueries(["securityClasses"]);
    },
  });
}

export function useUpdateSecurityClass() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: "updateSecurityClass",
    mutationFn: updateSecurityClass,
    onSuccess: () => {
      queryClient.invalidateQueries(["securityClasses"]);
    },
  });
}

export function useDeleteSecurityClass() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: "deleteSecurityClass",
    mutationFn: deleteSecurityClass,
    onSuccess: () => {
      queryClient.invalidateQueries(["securityClasses"]);
    },
  });
}
